import React from "react";
import ContentModerationView from "@/components/contentModeration/ContentModerationView";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Groups: basic details of one item with Deactivate / Reactivate / Delete.
 */
const GroupsModerationView = () => (
  <ContentModerationView sectionKey="groups" />
);

GroupsModerationView.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.groups.list,
    pathname: contentModeration.groups.list,
    active: false,
  },
  {
    name: breadcrumb_key.contentModeration.groups.view,
    pathname: "",
    active: true,
  },
];

export default GroupsModerationView;
